(function () {
  const MAP = {
    "37": { UK: "3.5", US: "4.5" },
    "38": { UK: "4.5", US: "5.5" },
    "39": { UK: "5",   US: "6"   },
    "40": { UK: "6",   US: "7"   },
    "41": { UK: "7",   US: "8"   },
    "42": { UK: "7.5", US: "8.5" },
    "43": { UK: "8.5", US: "9.5" },
    "44": { UK: "9",   US: "10"  },
    "45": { UK: "10",  US: "11"  },
    "46": { UK: "11",  US: "12"  },
    "47": { UK: "11.5",US: "12.5"}
  };

  const STORAGE_KEY = "joa_size_unit";
  const ALLOWED_UNITS = ["EU", "UK", "US"];

  function getRememberedUnit() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function rememberUnit(unit) {
    try { localStorage.setItem(STORAGE_KEY, unit); } catch (e) {}
  }

  function normalizeEU(raw) {
    const s = String(raw || "").trim();
    const m = s.match(/(\d{2})/); // 37..47
    return m ? m[1] : null;
  }

  function setActive(toggle, unit) {
    toggle.querySelectorAll(".size-unit-toggle__btn").forEach((btn) => {
      const active = (btn.dataset.unit || "").toUpperCase() === unit;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function formatLabel(originalEUText, unit) {
    if (unit === "EU") return originalEUText;

    const eu = normalizeEU(originalEUText);
    if (!eu) return originalEUText;

    const mapped = MAP[eu] && MAP[eu][unit];
    if (!mapped) return originalEUText;

    // Return like "US 10" / "UK 9"
    return `${unit} ${mapped}`;
  }

  // Cart drawer: always keep EU visible to avoid confusion
  function formatCartSize(originalEUText, unit) {
    const eu = normalizeEU(originalEUText);
    if (!eu) return originalEUText;

    if (unit === "EU") return `EU ${eu}`;

    const mapped = MAP[eu] && MAP[eu][unit];
    if (!mapped) return `EU ${eu}`;

    return `${unit} ${mapped} (EU ${eu})`;
  }

function updateCartDrawer(unit) {
  const nodes = document.querySelectorAll(".cart-size-value[data-eu]");
  if (!nodes.length) return;

  nodes.forEach((el) => {
    const next = formatCartSize(el.dataset.eu, unit);

    // Only write if changed (prevents mutation loops)
    if (el.textContent !== next) {
      el.textContent = next;
    }
  });
}

  function update(scope, unit) {
    // PDP size pills
    scope.querySelectorAll(".size-pill-label[data-eu]").forEach((el) => {
      el.textContent = formatLabel(el.dataset.eu, unit);
    });

    // Cart drawer
    updateCartDrawer(unit);

    // We intentionally do NOT change legend text (you wanted only "Select size")
  }

  function findScopeFrom(toggle) {
    return toggle.closest("variant-radios") || document;
  }

  function getInitialUnit(toggle) {
    const remembered = (getRememberedUnit() || "").toUpperCase();
    if (ALLOWED_UNITS.includes(remembered)) return remembered;

    const countryDefault = (toggle.dataset.defaultUnit || "EU").toUpperCase();
    if (ALLOWED_UNITS.includes(countryDefault)) return countryDefault;

    return "EU";
  }

/**
 * Robust cart-drawer watcher for Dawn:
 * - Drawer markup can be replaced after AJAX add-to-cart
 * - We re-bind observer when the target node changes
 */
function observeCartDrawer(getUnit) {
  let currentTarget = null;
  let drawerObserver = null;

  function bindToCurrentDrawer() {
    const nextTarget =
      document.getElementById("CartDrawer-CartItems") ||
      document.getElementById("CartDrawer");

    if (!nextTarget) return;

    // If Dawn replaced DOM node, re-bind
    if (nextTarget === currentTarget) return;

    currentTarget = nextTarget;

    if (drawerObserver) drawerObserver.disconnect();

    let scheduled = false;
    drawerObserver = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        updateCartDrawer(getUnit());
      });
    });

    drawerObserver.observe(currentTarget, { childList: true, subtree: true });

    // Apply immediately when (re)bound
    updateCartDrawer(getUnit());
  }

  // Watch the page for drawer being injected/replaced
  let scheduledBody = false;
  const bodyObserver = new MutationObserver((mutations) => {
    // Cheap filter: only react if something relevant was added/changed
    let relevant = false;

    for (const m of mutations) {
      if (m.type !== "childList") continue;

      // If nodes were added, check quickly for drawer-ish stuff
      for (const node of m.addedNodes) {
        if (!node || node.nodeType !== 1) continue;

        // element with id CartDrawer or CartDrawer-CartItems or contains them
        if (
          node.id === "CartDrawer" ||
          node.id === "CartDrawer-CartItems" ||
          node.querySelector?.("#CartDrawer, #CartDrawer-CartItems")
        ) {
          relevant = true;
          break;
        }
      }
      if (relevant) break;
    }

    if (!relevant) return;

    if (scheduledBody) return;
    scheduledBody = true;

    requestAnimationFrame(() => {
      scheduledBody = false;
      bindToCurrentDrawer();
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });

  // Initial bind (works on first load too)
  bindToCurrentDrawer();
}

  function init() {
    // Keep a global current unit so cart drawer can update even if toggle isn't on the page
    let currentUnit = "EU";

    document.querySelectorAll("[data-size-unit-toggle]").forEach((toggle) => {
      const scope = findScopeFrom(toggle);

      // Default unit (localStorage overrides country default)
      currentUnit = getInitialUnit(toggle);

      setActive(toggle, currentUnit);
      update(scope, currentUnit);

      toggle.addEventListener("click", (e) => {
        const btn = e.target.closest(".size-unit-toggle__btn");
        if (!btn) return;

        const next = (btn.dataset.unit || "EU").toUpperCase();
        currentUnit = ALLOWED_UNITS.includes(next) ? next : "EU";

        rememberUnit(currentUnit);
        setActive(toggle, currentUnit);
        update(scope, currentUnit);
      });

      // When Dawn updates variant radios, re-apply current unit labels
      document.addEventListener("change", (e) => {
        if (e.target && e.target.closest && e.target.closest("variant-radios")) {
          update(scope, currentUnit);
        }
      });
    });

    // If there is no toggle on the current page (but cart drawer exists),
    // still use remembered unit for cart formatting:
    const remembered = (getRememberedUnit() || "").toUpperCase();
    if (ALLOWED_UNITS.includes(remembered)) currentUnit = remembered;

    // Initial apply + observe AJAX updates
    updateCartDrawer(currentUnit);
    observeCartDrawer(() => currentUnit);
  }

  document.addEventListener("DOMContentLoaded", init);
})();
